export const ORDER_TYPES = {
  SETUP: 'Oppsett',
  MOVE: 'Flytting',
  SERVICE: 'Service'
};

export const ORDER_STATUS = {
  NEW: 'Ny',
  ASSIGNED: 'Tildelt',
  IN_PROGRESS: 'Pågår',
  COMPLETED: 'Fullført',
  REJECTED: 'Avvist'
};

export const ORDER_PRIORITY = {
  LOW: 'Lav',
  NORMAL: 'Normal',
  HIGH: 'Høy',
  URGENT: 'Akutt'
};

export const ISSUE_CATEGORIES = [
  'Batteri',
  'Mekanisk',
  'Elektronikk',
  'Konfigurasjon',
  'Annet'
];

export const ORDER_TYPE_OPTIONS = Object.values(ORDER_TYPES);
export const ORDER_STATUS_OPTIONS = Object.values(ORDER_STATUS);
export const ORDER_PRIORITY_OPTIONS = Object.values(ORDER_PRIORITY);
